exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".FancyOrderedList {\n  counter-reset: li;\n  padding-left: 40px; }\n  .FancyOrderedList li {\n    position: relative;\n    list-style: none;\n    margin-bottom: 24px;\n    line-height: 24px; }\n  .FancyOrderedList li::before {\n    display: block;\n    position: absolute;\n    top: -1px;\n    right: 100%;\n    content: counter(li);\n    counter-increment: li;\n    width: 24px;\n    margin-right: 16px;\n    text-align: center;\n    border: 1px solid #8300c5;\n    border-radius: 24px;\n    line-height: 24px;\n    color: #8300c5; }\n", ""]);

// exports
